import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui'
import { actions as operationActions } from 'ducks/uiOperations'
import { actions as formActions } from 'ducks/form'
import { selectors as invoiceSelector, actions as invoiceActions } from 'ducks/supplierEnquiry/activity/invoices'
import { fetch } from 'api/supplierEnquiry/activity/invoices'
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters'
import { selectors as supplierSelectors } from 'ducks/supplierEnquiry/supplier';


export const mapStateToProps = state => {
  const params = new URLSearchParams(location.search)
  return {
    gridName: 'SupplierActivityInvoices',
    columnDefs: invoiceSelector.columns(state),
    isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
    gridOptions: invoiceSelector.gridOptions(state),
    filterRow: invoiceSelector.filterRow(state),
    selectedFilters: invoiceSelector.selectedFilters(state),
    appliedFilters: invoiceSelector.filterRow(state) && filterSelectors.getFilters(state, invoiceSelector.filterRow(state).formName),
    reqParams: (supplierSelectors.selected(state) || params.get('Supplier'))
      &&
    {
      SupplierId: (supplierSelectors.selected(state) && supplierSelectors.selected(state).Supplier) || params.get('Supplier')
    },
    apiMethod: supplierSelectors?.selected(state)?.Supplier || params?.get('Supplier') ? fetch : () => Promise.resolve(null)
  }
};

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: invoiceActions.setSelected,
  applyFilters: filterActions.applyFilters
}
